// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /round/get-board.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeRoundGetBoardBody,
  typeRoundGetBoardOutput200,
} from "../../sdk/round/postRoundGetBoard";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildRoundGetBoardQueryKey(
  payload: typeRoundGetBoardBody,
): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`poolId:${JSON.stringify(payload.poolId)}`);
  queryKeySegments.push(`contestId:${JSON.stringify(payload.contestId)}`);
  queryKeySegments.push(`roundId:${JSON.stringify(payload.roundId)}`);
  if (typeof payload.entryId !== "undefined") {
    queryKeySegments.push(`entryId:${JSON.stringify(payload.entryId)}`);
  }
  return ["post:round:roundGetBoard", "svc:contest-api", ...queryKeySegments];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeRoundGetBoardOutput200,
    unknown,
    typeRoundGetBoardOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useRoundGetBoard(
  payload: typeRoundGetBoardBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildRoundGetBoardQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postRoundGetBoard(payload),
    ...resolvedOptions,
  });
}
